import api from "./api";

// Booking audit log endpoints — gated by the "view_booking_logs" permission
// (distinct from "view_bookings"/"view_booking_details", so a role needs it
// granted separately). Read-only: there is no create/update/delete here,
// entries are written server-side whenever a booking's status changes.

// GET /api/booking-logs — searchable, paginated. Params (all optional):
// page, per_page (capped at 100 server-side, default 20), booking_id,
// payment_id, payment_reference, member_id, member_code, triggered_by,
// from_date, to_date, search (matches summary/booking id/member name/
// payment reference). Returns { data: [...], meta: { total, page, per_page } }
// — each row: { id, booking_id, member_id, member_code, member_name,
// payment_id, payment_reference, previous_status, previous_status_id,
// new_status, new_status_id, triggered_by, triggered_by_label,
// triggered_by_user_id, triggered_by_user_name, summary, created_at }.
export const listBookingLogs = (params = {}) =>
  api.get("/api/booking-logs", { params }).then((r) => r.data);

// GET /api/booking-logs/filters — { triggered_by: [{value, label}, ...] }
// (the six trigger types: MEMBER_WEB, STAFF_SHROFF, PAYMENT_GATEWAY,
// SYSTEM_EXPIRY, SYSTEM_COMPLETE, MANUAL_ADMIN). Used to populate the
// "Triggered by" filter dropdown without hardcoding the label strings.
export const getBookingLogFilters = () =>
  api.get("/api/booking-logs/filters").then((r) => r.data);

// GET /api/bookings/{id}/logs — full timeline for one booking, oldest-first
// (the list endpoint above is newest-first). 404s with { message: "Booking
// not found." } if the id doesn't exist. Returns { booking: { id, member_id,
// member_code, member_name, facility_id, facility_name, total_entries,
// total_fee, booking_status, payment_status, payment_id, payment_reference,
// created_by_staff, created_at }, logs: [...] } — each log entry has the
// same fields as a list row plus facility_booking_id, entity_type
// ("booking" | "facility_booking" | "booking_payment"), entity_id, and a
// decoded `payload` object (or null).
export const getBookingLogTimeline = (bookingId) =>
  api.get(`/api/bookings/${bookingId}/logs`).then((r) => r.data);
